import {
    DownOutlined,
    UpOutlined,
    HomeOutlined
} from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthData, useFilterDetails } from './global.jsx';
import { TbHeartRateMonitor, TbChartLine, TbHistory, TbBuilding, TbShip, TbClock } from "react-icons/tb";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import FilterObject from './FilterObject';

const Sidebar = ({ isOpen, toggleSidebar, isCollapsed, toggleCollapse }) => {
    const user = AuthData();
    const navigate = useNavigate();
    const [openSubMenu, setOpenSubMenu] = useState(null);
    const location = useLocation();
    const { filterDetails, isLoading } = useFilterDetails();
    // const { lastUpdate } = useSensorData();

    // Get lastUpdate from localStorage to avoid unnecessary API calls
    const [lastUpdate, setLastUpdate] = useState(null);

    useEffect(() => {
        const getLastUpdate = () => {
            const dataFilter = localStorage.getItem('Filter');
            if (dataFilter) {
                // const parsedData = JSON.parse(dataFilter);
                // Get lastUpdate from localStorage or set current time
                const storedLastUpdate = localStorage.getItem('lastUpdate');
                if (storedLastUpdate) {
                    setLastUpdate(storedLastUpdate);
                } else {
                    setLastUpdate(new Date().toISOString());
                }
            }
        };

        getLastUpdate();

        // Listen for filter changes
        const handleFilterChange = () => {
            getLastUpdate();
        };

        window.addEventListener('filterUpdated', handleFilterChange);

        return () => {
            window.removeEventListener('filterUpdated', handleFilterChange);
        };
    }, []);

    const handleItemClick = () => {
        if (window.innerWidth < 1024 && isOpen) {
            toggleSidebar();
        }
    };


    const handleSubMenuClick = (menuName) => {
        setOpenSubMenu(openSubMenu === menuName ? null : menuName);
    };

    const menu = [
        {
            nama: "Dashboard",
            urlLink: "/dashboard",
            icon: <HomeOutlined className="text-lg" />,
            description: "Overview"
        },
        ...(user && user.role === "Admin" ? [
            {
                nama: "History",
                urlLink: "/dashboard/history",
                icon: <TbHistory className="text-lg" />,
                description: "Data History"
            },
            {
                nama: "Analytic",
                urlLink: "/dashboard/analytic",
                icon: <TbChartLine className="text-lg" />,
                description: "Data Analysis"
            },
            {
                nama: "Monitoring",
                urlLink: "/monitoring",
                icon: <TbHeartRateMonitor className="text-lg" />,
                description: "Live Monitor"
            },
        ] : [])
    ];

    const SubMenu = ({ items }) => {
        return (
            <div className="ml-4 space-y-1 transition-all duration-300 ease-in-out">
                {items.map((subItem, index) => {
                    return (
                        <Link
                            key={index}
                            to={subItem.urlLink}
                            onClick={handleItemClick}
                            className={`block px-4 py-2 rounded-lg text-sm transition-all duration-200 hover:bg-white/10 ${location.pathname === subItem.urlLink
                                ? 'bg-primary-500/20 text-primary-300 border-l-2 border-primary-500'
                                : 'text-gray-300 hover:text-white'
                                }`}
                        >
                            {subItem.nama}
                        </Link>
                    );
                })}
            </div>
        );
    };

    const handleClick = (item) => {
        const dataFilter = localStorage.getItem('Filter');
        if (dataFilter) {
            const parsedData = JSON.parse(dataFilter);
            const queryParams = new URLSearchParams({
                KodeCabang: parsedData.KodeCabang,
                ShipCode: parsedData.ShipCode,
            }).toString();
            navigate(`${item.urlLink}?${queryParams}`);
        } else {
            navigate(item.urlLink);
        }
        if (item.urlLink) {
            handleItemClick();
        }
        if (item.subMenu) {
            handleSubMenuClick(item.nama);
        }
    }

    return (
        <>
            {/* Mobile Overlay */}
            {isOpen && (
                <div
                    className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 lg:hidden"
                    onClick={toggleSidebar}
                />
            )}

            {/* Sidebar */}
            <div
                className={`bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 text-white fixed inset-y-0 left-0 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'
                    } transition-all duration-300 ease-in-out lg:translate-x-0 h-full z-50 shadow-2xl`}
                style={{
                    width: isCollapsed ? '64px' : '320px',
                    transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1), transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                }}
            >
                {/* Sidebar Header */}
                <div
                    className="border-b border-white/10 transition-all duration-300 ease-in-out"
                    style={{ padding: isCollapsed ? '12px' : '24px' }}
                >
                    <div
                        className={`flex items-center relative transition-all duration-300 ease-in-out ${isCollapsed ? 'justify-center' : 'space-x-3'}`}
                        style={{ marginBottom: isCollapsed ? '0' : '16px' }}
                    >
                        {/* <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-lg"> */}
                        {/* <TbHeartRateMonitor className="text-white text-xl" /> */}
                        <img
                            src="/assets/favicon/favicon-96x96.png"
                            className="w-10 h-10 p-[2px] rounded-full bg-white"
                            alt="NextSense Icon"
                        />
                        {/* </div> */}
                        <div
                            className={`transition-all duration-300 ease-in-out overflow-hidden ${isCollapsed ? 'w-0 opacity-0' : 'w-auto opacity-100'}`}
                        >
                            <h2 className="text-lg font-bold whitespace-nowrap">NextSense</h2>
                            <p className="text-xs text-gray-400 whitespace-nowrap">Monitoring System</p>
                        </div>

                        <div
                            className={`absolute right-0 hidden lg:block transition-all duration-300 ease-in-out ${isCollapsed ? 'opacity-0' : 'opacity-100'}`}
                            style={{ marginTop: '16px' }}
                        >
                            <button
                                onClick={toggleCollapse}
                                className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors duration-200"
                                title={isCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}
                            >
                                <HiChevronLeft className="w-4 h-4" />
                            </button>
                        </div>

                    </div>

                    {/* Filter Object */}
                    <div
                        className={`w-full transition-all duration-300 ease-in-out overflow-hidden ${isCollapsed ? 'h-0 opacity-0' : 'h-auto opacity-100'}`}
                    >
                        <FilterObject />
                    </div>

                    {/* Collapse Toggle Button */}
                    {isCollapsed && (
                        <div
                            className={`hidden lg:block transition-all duration-300 ease-in-out opacity-100`}
                            style={{ marginTop: '16px' }}
                        >
                            <div className="flex justify-center">
                                <button
                                    onClick={toggleCollapse}
                                    className="p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors duration-200"
                                    title={isCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar'}
                                >
                                    <HiChevronRight className="w-4 h-4" />
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                {/* Branch & Ship Info */}
                <div
                    className={`border-b border-white/10 bg-white/5 transition-all duration-300 ease-in-out overflow-hidden ${isCollapsed ? 'h-0 opacity-0 p-0' : 'h-auto opacity-100 p-4'}`}
                >
                    <div className="space-y-3">
                        <div className="flex items-start space-x-3">
                            <div className="w-8 h-8 bg-blue-500/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                                <TbBuilding className="text-blue-300 text-sm" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="text-xs text-gray-400 uppercase tracking-wider font-medium">Branch</p>
                                {isLoading ? (
                                    <div className="animate-pulse">
                                        <div className="h-4 bg-gray-600 rounded w-24"></div>
                                    </div>
                                ) : (
                                    <p className="text-sm text-white font-medium truncate" title={filterDetails?.NamaCabang}>
                                        {filterDetails?.NamaCabang || 'Loading...'}
                                    </p>
                                )}
                            </div>
                        </div>
                        <div className="flex items-start space-x-3">
                            <div className="w-8 h-8 bg-green-500/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                                <TbShip className="text-green-300 text-sm" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="text-xs text-gray-400 uppercase tracking-wider font-medium">Vessel</p>
                                {isLoading ? (
                                    <div className="animate-pulse">
                                        <div className="h-4 bg-gray-600 rounded w-32"></div>
                                    </div>
                                ) : (
                                    <p className="text-sm text-white font-medium truncate" title={filterDetails?.ShipName}>
                                        {filterDetails?.ShipName || 'Loading...'}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Last Update Info */}
                {/* {lastUpdate && (
                    <div
                        className={`border-b border-white/10 bg-gradient-to-r from-purple-500/10 to-blue-500/10 transition-all duration-300 ease-in-out overflow-hidden ${isCollapsed ? 'h-0 opacity-0 p-0' : 'h-auto opacity-100 p-4'}`}
                    >
                        <div className="flex items-start space-x-3">
                            <div className="w-8 h-8 bg-purple-500/20 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                                <TbClock className="text-purple-300 text-sm" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="text-xs text-gray-400 uppercase tracking-wider font-medium">Last Update</p>
                                <p className="text-sm text-white font-medium" title={lastUpdate}>
                                    {new Date(lastUpdate).toLocaleString('id-ID', {
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit'
                                    })}
                                </p>
                                <div className="flex items-center space-x-1 mt-1">
                                    <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                                    <span className="text-xs text-green-300">Live Data</span>
                                </div>
                            </div>
                        </div>
                    </div>
                )} */}

                {/* Navigation Menu */}
                <nav
                    className="flex-1 space-y-2 transition-all duration-300 ease-in-out"
                    style={{ padding: isCollapsed ? '8px' : '16px' }}
                >
                    {menu.map((item, index) => (
                        <div key={index} className="relative">
                            <button
                                onClick={() => handleClick(item)}
                                className={`w-full group flex items-center ${isCollapsed ? 'justify-center px-2 py-3' : 'space-x-3 px-4 py-3'} rounded-xl transition-all duration-200 ${location.pathname === item.urlLink
                                    ? 'bg-primary-500/20 text-primary-300 border border-primary-500/30 shadow-lg'
                                    : 'text-gray-300 hover:bg-white/10 hover:text-white'
                                    }`}
                            >
                                <div className={`p-2 rounded-lg transition-colors duration-200 ${location.pathname === item.urlLink
                                    ? 'bg-primary-500/30'
                                    : 'bg-gray-700/50 group-hover:bg-white/10'
                                    }`}>
                                    {item.icon}
                                </div>
                                <div
                                    className={`flex-1 text-left transition-all duration-300 ease-in-out overflow-hidden ${isCollapsed ? 'w-0 opacity-0' : 'w-auto opacity-100'}`}
                                >
                                    <p className="font-medium whitespace-nowrap">{item.nama}</p>
                                    <p className="text-xs text-gray-400 group-hover:text-gray-300 whitespace-nowrap">
                                        {item.description}
                                    </p>
                                </div>
                                {item.subMenu && (
                                    <div
                                        className={`transition-all duration-300 ease-in-out ${isCollapsed ? 'w-0 opacity-0' : 'w-auto opacity-100'}`}
                                    >
                                        <div className="transition-transform duration-200">
                                            {openSubMenu === item.nama ?
                                                <UpOutlined className="text-sm" /> :
                                                <DownOutlined className="text-sm" />
                                            }
                                        </div>
                                    </div>
                                )}
                            </button>

                            {/* Tooltip for collapsed state */}
                            {isCollapsed && (
                                <div className="absolute left-full ml-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50 whitespace-nowrap">
                                    <div className="font-medium">{item.nama}</div>
                                    <div className="text-xs text-gray-300">{item.description}</div>
                                    <div className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-1 w-2 h-2 bg-gray-900 rotate-45"></div>
                                </div>
                            )}

                            {item.subMenu && openSubMenu === item.nama && (
                                <div
                                    className={`transition-all duration-300 ease-in-out overflow-hidden ${isCollapsed ? 'h-0 opacity-0' : 'h-auto opacity-100'}`}
                                >
                                    <SubMenu items={item.subMenu} />
                                </div>
                            )}
                        </div>
                    ))}
                </nav>

                {/* Sidebar Footer */}
                {/* <div className="p-4 border-t border-white/10">
                    <div className="flex items-center space-x-3 p-3 rounded-xl bg-white/5">
                        <div className="w-8 h-8 bg-gradient-to-br from-success-500 to-success-600 rounded-full flex items-center justify-center">
                            <span className="text-white text-sm font-bold">
                                {user && user.Name ? user.Name.charAt(0) : 'U'}
                            </span>
                        </div>
                        <div className="flex-1">
                            <p className="text-sm font-medium">{user && user.Name}</p>
                            <p className="text-xs text-gray-400">{user && user.Role}</p>
                        </div>
                        <div className="w-2 h-2 bg-success-500 rounded-full animate-pulse"></div>
                </div>
                </div> */}
            </div>
        </>
    );
};

export default Sidebar;
